export default class CertRequirement {
  constructor(API) {
    this.api = API;
  }
  async createCertRequirement(certificationID, requirementObj, type) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/certification/${certificationID}/requirement/new/type/${type}`;
    req.body = requirementObj;
    return await req.exec();
  }
  async updateCertRequirement(certificationID, requirementObj, type) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/certification/${certificationID}/requirement/${requirementObj.id}/type/${type}`;
    req.body = requirementObj;
    return await req.exec();
  }
  async deleteCertRequirement(certificationID, requirementID, type) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/certification/${certificationID}/requirement/${requirementID}/type/${type}`;
    return await req.exec();
  }
  async getCertRequirement(certificationID, requirementID, type) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/certification/${certificationID}/requirement/${requirementID}/type/${type}`;
    return await req.exec();
  }
  async getAllCertRequirements(certificationID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/certification/${certificationID}/requirements`;
    return await req.exec();
  }
}
